<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Travel Requests</h1>
      <router-link to="/request/travel/add" class="button is-primary is-small is-uppercase">Add</router-link>
    </div>
    <div class="box" style="margin-top: 12px;">
      <component-search></component-search>
      <component-filters></component-filters>
    </div>
    <travel-table class="is-hidden-mobile"></travel-table>
    <travel-list class="is-hidden-tablet"></travel-list>
    <app-paginate module="travel"></app-paginate>
  </div>
</template>
<script>
import ComponentSearch from "./components/search";
import ComponentFilters from "./components/filters";
import TravelTable from "./components/travel-table";
import TravelList from "./components/travel-list";
export default {
  components: {
    ComponentSearch,
    ComponentFilters,
    TravelTable,
    TravelList
  },
  mounted() {
    let component = this;
    component.$store.commit("travel/page", 1);
    component.$store.commit("travel/limit", 10);
    component.$store.commit("travel/role", "all");
    component.$store.commit("travel/docs", []);
    component.$store.commit("travel/totalDocs", 0);
    component.$store.commit("travel/totalPages", 0);
    component.$store.dispatch("travel/index");
  }
};
</script>
<style lang="scss" scoped>
.is-flex {
  .view-title {
    flex-basis: 0;
    flex-grow: 1;
  }
  .add-button {
    margin-top: 12px;
  }
}
</style>
